import { NavLink, Link } from 'react-router-dom';
import { CartContext } from '../context/CartContext';
import React, { useContext, useState, useEffect } from 'react';
import { useUser } from '../context/UserContext';
import { FavoritesContext } from '../context/FavoritesContext';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { API_URL } from '../config/api';

const backend = API_URL;

const Navbar = () => {
  const [display, setDisplay] = useState(false);
  const [search, setSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const { cart } = useContext(CartContext);
  const { favorites } = useContext(FavoritesContext);
  const { user, logout } = useUser();

  const navigate = useNavigate();

  // Menu / Recherche
  const showMenu = () => setDisplay(true);
  const closeMenu = () => setDisplay(false);
  const showSearch = () => setSearch(true);
  const closeSearch = () => {
    setSearch(false);
    setSuggestions([]);
  };

  // Envoi recherche
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?query=${encodeURIComponent(searchTerm)}`);
      setSuggestions([]);
      setSearch(false);
    }
  };

  // Suggestions auto-complete
  useEffect(() => {
    if (searchTerm.length > 1) {
      const fetchSuggestions = async () => {
        try {
          const res = await axios.get(`${backend}/products`);
          const filtered = res.data.filter(p =>
            p.title.toLowerCase().includes(searchTerm.toLowerCase())
          );
          setSuggestions(filtered.slice(0, 5));
        } catch (err) {
          console.error(err);
        }
      };
      fetchSuggestions();
    } else {
      setSuggestions([]);
    }
  }, [searchTerm]);

  const handleSuggestionClick = (title) => {
    setSearchTerm(title);
    navigate(`/search?query=${encodeURIComponent(title)}`);
    setSuggestions([]);
    setSearch(false);
  };

  return (
    <div>
      {/* NAVBAR PRINCIPALE */}
      <div className='navbar'>
        <div className="navbar--left">
          <div className="navbar--logo">
            <div className='icon--menu' onClick={showMenu}>
              <i className="fa-solid fa-bars"></i>
            </div>
            {/* <NavLink to="/">
              <h5 className='header__title'>Code<span>Shop225</span></h5>
            </NavLink> */}
            <div className='logo__box'>
               <NavLink to="/"><img src="/IMG_9959.PNG" alt="" /></NavLink>
            </div>
          </div>
        </div>

        <div className="navbar--center">
          <div className="navbar--center--content">
            <form className="d-flex" role="search" onSubmit={handleSearchSubmit}>
              <input
                className="form-control me-2"
                type="search"
                placeholder="Rechercher..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button className="btn btn-outline-success" type="submit">Recherche</button>
            </form>

          {/* Autocomplete mobile */}
{suggestions.length > 0 && (
  <ul className="autocomplete-suggestions">
    {suggestions.map(item => (
      <li
        key={item._id}
        onClick={() => handleSuggestionClick(item.title)}
        className="autocomplete-item"
      >
        <img
          src={
            item.img?.startsWith("http")
              ? item.img
              : `${API_URL}/uploads/${item.img}`
          }
          alt={item.title}
          className="autocomplete-img"
        />
        <span className="autocomplete-text">{item.title}</span>
      </li>
    ))}
  </ul>
)}
          </div>
        </div>

        <div className="navbar--right">
          <div className="navbar--right--content">
            <div className='user__profil__box'>
              {user ? (
                <>
                  <div className='cart__box'>
                    <i className="fa-solid fa-magnifying-glass" onClick={showSearch}></i>
                  </div>
                  <Link to="/cart" className='cart__box'>
                    <i className="fa-solid fa-cart-shopping"></i>
                    <div className='icon__counter'>({cart.length})</div>
                  </Link>
                  <Link to="/Profil">
                    <p className='user__name'><i className="fa-solid fa-user"></i> {user.name}</p>
                  </Link>
                   <Link to="/Profil" className="user__name__res" title="Mon profil">
                  <i className="fa-solid fa-user" />
                </Link>
                  <button className='user__btn__logout' onClick={logout}>
                    Logout <i className="fa-solid fa-arrow-right-from-bracket"></i>
                  </button>
                </>
              ) : (
                <>
                 <div className='cart__box'>
                    <i className="fa-solid fa-magnifying-glass" onClick={showSearch}></i>
                  </div>
                  <NavLink className='liste' to="/login">
                  <button className="btn--connexion"><i className="fa-solid fa-user"></i> Se connecter</button>
                </NavLink>
                  </>
                
              )}
            </div>
          </div>
        </div>
      </div>

      {/* SIDEBAR MENU */}
      <div className={display ? "menu show--menu" : "menu"}>
        <div className='sidebar--menu'>
          <div className='btn--close--sidebar' onClick={closeMenu}>
            <i className="fa-solid fa-xmark"></i>
          </div>
           <div className='logo__box'>
              <NavLink to="/"><img src="/IMG_9959.PNG" alt="" /></NavLink>
            </div>
          <div className='menu__content'>
            <div className='menu__content__liste'>
                <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-solid fa-house"></i> Accueil</NavLink>
            </div>
            <div className='menu__content__liste'>
               <NavLink to='/fr/PS4' className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-solid fa-gamepad" /> PS4</NavLink>
            </div>

            <div className='menu__content__liste'>
               <NavLink to='/fr/PS5' className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-solid fa-gamepad" /> PS5</NavLink>
            </div>
              <div className='menu__content__liste'>
                 <NavLink to='/CD' className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-solid fa-compact-disc"></i> CD</NavLink>
            </div>

             <div className='menu__content__liste'>
                 <NavLink to='/Cartes__PSN' className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-brands fa-playstation" /> PSN</NavLink>
            </div>

              <div className='menu__content__liste'>
                 <NavLink to='/boutique' className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-solid fa-shop"></i> Boutique</NavLink>
           </div>

           
           <div className='menu__content__liste'>
                 <NavLink to='/Cartes__itunes' className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-brands fa-apple" /> iTunes</NavLink>
           </div>

           <div className='menu__content__liste'>
              <NavLink to="/nouveautes" className={({ isActive }) => isActive ? "active" : ""}><i className="fa-solid fa-newspaper"></i> Nouveautés</NavLink>
           </div>
           <div className='menu__content__liste'>
              <NavLink to="/Contactez-nous" className={({ isActive }) => isActive ? "active" : ""}><i className="fa-solid fa-phone"></i> Contact</NavLink>
           </div>
           <div className='menu__content__liste'>
                <NavLink to="/mes-commandes" className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-solid fa-box"></i> Mes commandes</NavLink>
           </div>
           <div className='menu__content__liste'>
                 <NavLink to="/Profil" className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-solid fa-circle-user"></i> Mon profil</NavLink>
           </div>
          </div>
        </div>
      </div>

      {/* RECHERCHE FLOTTANTE MOBILE AVEC AUTOCOMPLETE */}
      <div className={search ? "search show--search" : "search"}>
        <div className='search--content'>
          <div className='btn--close--search' onClick={closeSearch}>
            <i className="fa-solid fa-xmark"></i>
          </div>
          <form className="d-flex" role="search" onSubmit={handleSearchSubmit}>
            <input
              className="form-control me-1"
              type="search"
              placeholder="Rechercher..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button className="btn__searching" type="submit">Recherche</button>
          </form>

          {/* Autocomplete mobile */}
{suggestions.length > 0 ? (
  <ul className="autocomplete-suggestions">
    {suggestions.map(item => (
      <li
        key={item._id}
        onClick={() => handleSuggestionClick(item.title)}
        className="autocomplete-item"
      >
        <img
          src={
            item.img?.startsWith("http")
              ? item.img
              : `${API_URL}/uploads/${item.img}`
          }
          alt={item.title}
          className="autocomplete-img"
        />
        <span className="autocomplete-text">{item.title}</span>
      </li>
    ))}
  </ul>
) : (
  <div className="autocomplete-no-result">
              Aucun produit trouvé ❌
            </div>
          )}
        </div>
      </div>

      {/* MENU MOBILE FIXE */}
      <div className='header__bar'>
        <div className="nav__left">
          <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}> <i className="fa-solid fa-house"></i> Accueil</NavLink>
          <NavLink to='/fr/PS4' className={({ isActive }) => isActive ? 'active' : ''}> <i className="fa-solid fa-gamepad" />PS4</NavLink>
          <NavLink to='/fr/PS5' className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-solid fa-gamepad" /> PS5</NavLink>
          <NavLink to='/CD' className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-solid fa-compact-disc"></i> CD</NavLink>
          <NavLink to='/Cartes__PSN' className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-brands fa-playstation" /> PSN</NavLink>
          <NavLink to='/boutique' className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-solid fa-shop"></i> Boutique</NavLink>
          <NavLink to='/Cartes__itunes' className={({ isActive }) => isActive ? 'active' : ''}> <i className="fa-brands fa-apple" /> iTunes</NavLink>
          <NavLink to="/nouveautes" className={({ isActive }) => isActive ? "active" : ""}>🆕 Nouveautés</NavLink>
        </div>
        <div className="nav__right">
          <NavLink to="/Contactez-nous" className={({ isActive }) => isActive ? 'active' : ''}> <i className="fa-solid fa-phone"></i> Contact</NavLink>
          <NavLink to="/cart" className={({ isActive }) => isActive ? 'active' : ''}> <i className="fa-solid fa-cart-shopping"></i> Panier ({cart.length})</NavLink>
          <NavLink to="/mes-commandes" className={({ isActive }) => isActive ? 'active' : ''}><i className="fa-solid fa-box"></i> Mes commandes</NavLink>
        </div>
      </div>

      {/* Styles auto-complete */}
      <style>{`
        .autocomplete-suggestions {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: #fff;
          border: 1px solid #ccc;
          border-top: none;
          z-index: 1000;
          max-height: 200px;
          overflow-y: auto;
          border-radius: 0 0 6px 6px;
        }
        .autocomplete-suggestions li {
          padding: 8px 12px;
          cursor: pointer;
        }
        .autocomplete-suggestions li:hover {
          background-color: #f0f0f0;
        }
      `}</style>
    </div>
  );
};

export default Navbar;